@use "../../../../src/styles/Constants.scss" as Constants;

.container {
	padding: Constants.$val-spacing-l 0;
}

.submitButton {
	margin: 0px Constants.$val-spacing-xxxl
}
